/** Форматирование для интерфейса: цены, склонения, телефоны. Всё по-русски. */

const pluralRules = new Intl.PluralRules('ru-RU');

/**
 * Склонение по числу: plural(3, ['машина', 'машины', 'машин']) → «3 машины».
 * Формы: one (1, 21), few (2–4, 22–24), many (5–20, 25…).
 */
export function plural(n: number, forms: readonly [one: string, few: string, many: string], withNumber = true): string {
  const rule = pluralRules.select(n);
  const word = rule === 'one' ? forms[0] : rule === 'few' ? forms[1] : forms[2];
  return withNumber ? `${formatNumber(n)} ${word}` : word;
}

const numberFormat = new Intl.NumberFormat('ru-RU', { maximumFractionDigits: 0 });

/** Неразрывный пробел: «4 100 ₽» и «45 мин» не разрываются переносом. */
export const NBSP = String.fromCharCode(0xa0);

export function formatNumber(n: number): string {
  return numberFormat.format(n);
}

/** «4 100 ₽» с неразрывными пробелами. */
export function formatPrice(rub: number): string {
  return `${numberFormat.format(rub)}${NBSP}₽`;
}

export function formatPriceFrom(rub: number): string {
  return `от${NBSP}${formatPrice(rub)}`;
}

/** Название позиции записи: у поштучной услуги — «Перебортовка колеса × 6 колёс». */
export function itemLabel(item: { name: string; qty?: number | null }): string {
  return typeof item.qty === 'number' ? `${item.name} × ${plural(item.qty, ['колесо', 'колеса', 'колёс'])}` : item.name;
}

/** «1 ч 15 мин», «45 мин». */
export function formatDuration(minutes: number): string {
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  if (h === 0) return `${m}${NBSP}мин`;
  if (m === 0) return `${h}${NBSP}ч`;
  return `${h}${NBSP}ч ${m}${NBSP}мин`;
}

/** +79001234567 → «+7 900 123-45-67». Остальные номера — как есть. */
export function formatPhone(e164: string): string {
  const m = /^\+7(\d{3})(\d{3})(\d{2})(\d{2})$/.exec(e164);
  if (!m) return e164;
  return `+7${NBSP}${m[1]}${NBSP}${m[2]}-${m[3]}-${m[4]}`;
}
